export default __webpack_public_path__ + "static/media/female-curvey.c168b557.webp";